<template>
  <div class="backborder2">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px; margin-top: 30px;">
      <!-- 现有的表单内容 -->
      <el-form-item label="组合封面图" prop="image">
        <el-upload ref="uploadRes" :action="uploadUrl" :data="{ sys_type: 'cz', intranet_token:'Tzx9VY0OOGjUYZRb' }" :file-list="fileList" list-type="picture-card" :limit="1"
          :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeUpload"
          :on-success="handleUpdateSuccess">
          <i class="el-icon-plus"></i>
          <template slot="tip">
            <span style="display: flex;height: 100%; align-items: center;color: #C0C4CC;">（只能上传一张封面图）</span>
          </template>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>
      <el-form-item label="组合名称" prop="name">
        <el-input v-model="form.name" type="text" maxlength="40" show-word-limit size="small">
          <template slot="append">{{ form.name.length }}/40</template>
        </el-input>
      </el-form-item>
      <el-form-item label="组合价格" prop="price">
        <el-input-number v-model="form.price" :min="0" :precision="2" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="划线价格" prop="underline_price">
        <el-input-number v-model="form.underline_price" :min="0" :precision="2" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="限购类型">
        <el-select v-model="form.limit_type" placeholder="请选择限购类型" size="small" style="width: 130px;">
          <el-option label="不限购" value="0"></el-option>
          <el-option label="按每人限购" value="1"></el-option>
          <el-option label="按每店限购" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="限购数量" v-if="form.limit_type != 0" prop="limit_num">
        <el-input-number v-model="form.limit_num" :min="1" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="组合虚拟销量" prop="virtual_sales">
        <el-input-number v-model="form.virtual_sales" :min="0" size="small"></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="运费模板" prop="virtual_sales">
        <el-select v-model="form.shipping_template_id" placeholder="请选择" size="small" style="width: 130px;">
          <el-option v-for="item in shippingTemplates" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="运费模板">
        <el-select v-model="form.shipping_tempidid" placeholder="请选择">
          <el-option v-for="item in shippingtemplists" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getshippingtemplists"></el-button> -->
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch v-model="form.status" active-text="上架" active-value="1" inactive-text="下架"
          inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>

    <!-- 商品组合设置 -->
    <div v-for="(combination, index) in combinations" :key="index" class="combination-box">
      <div class="combination-header">
        <div class="header-left">
          <div class="flex-box">
            <span class="header-label">搭配名称</span>
            <el-input v-model="combination.name" size="small" placeholder="搭配名称"
              style="width: 150px; margin-right: 10px;"></el-input>
          </div>
          <div class="flex-box">
            <span class="header-label">搭配任选数量限制</span>
            <el-input-number v-model="combination.limit_num" size="small" :min="2" :max="9999" placeholder="搭配任选数量限制"
              style="width: 150px;"></el-input-number>
          </div>
        </div>
        <div class="header-right">
          <el-button type="primary" size="small" @click="addSku(index)">新增商品SKU</el-button>
          <el-button type="danger" size="small" @click="removeCombination(index)">删除组合</el-button>
        </div>
      </div>
      <el-table :data="combination.skus" style="width: 100%">
        <el-table-column prop="sku" label="SKUID"></el-table-column>
        <el-table-column prop="productInfo" label="商品信息" width="400px">
          <template slot-scope="scope">
            <div class="goodsInfo">
              <div class="left">
                <img :src="scope.row.img">
              </div>
              <div class="right">
                <div class="name">{{ scope.row.name }}</div>
                <div class="prop" style="margin-top: 10px;">{{ scope.row.property_name }} {{ scope.row.spec }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="brand_name" label="所属品牌"></el-table-column>
        <el-table-column prop="weight" label="重量（kg）"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="property_price" label="批发价格"></el-table-column>
        <el-table-column prop="activity_price" label="组合活动单价" align="center" width="160px">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.activity_price" size="small" :min="0"
              style="width: 140px;"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="inventory" label="可用库存"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="removeSku(combination, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-top: 20px;margin-bottom: 20px;">
      <el-button type="primary" @click="addCombination">新增组合搭配</el-button>
    </div>
    <div style="display: flex; justify-content: flex-end;width: 100%;">
      <!-- <el-button @click="addCombination">取消</el-button> -->
      <el-button type="primary" :loading="loading" @click="saveCombination">保存</el-button>
    </div>

    <CombinationSku ref="skuDialog" @chooseSku="handleChooseSku" />
  </div>
</template>

<script>
import CombinationSku from './CombinationSku.vue';

export default {
  name: 'CombinationEdit',
  components: {
    CombinationSku,
  },
  props: ['childdata'],
  watch: {
    childdata: {
      handler(newValue, oldValue) {
        if (newValue.id) {
          // 编辑
          this.form.id = newValue.id
          this.getDetail()
        } else {
          // 新增
        }
        this.getshippingtemplists()

      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    imageList() {
      return this.form.image ? [{ url: this.form.image }] : [];
    }
  },
  data() {
    return {
      loading: false,
      uploadUrl: this.GLOBAL.uploadUrl,
      fileList: [],
      form: {
        image: null,
        name: '',
        price: 0,
        underline_price: 0,
        limit_num: false,
        limit_type: '0',
        limit_num: 1,
        virtual_sales: 0,
        status: '1',
        shipping_tempidid: '',
      },
      rules: {
        image: [
          { required: true, message: '请上传组合封面图', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入组合名称', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入组合价格', trigger: 'change' },
          { type: 'number', min: 0, message: '价格必须大于等于0', trigger: 'change' }
        ],
        underline_price: [
          { required: true, message: '请输入划线价格', trigger: 'change' },
          { type: 'number', min: 0, message: '划线价格必须大于等于0', trigger: 'change' }
        ],
        limit_num: [
          { required: false, message: '请输入限购数量', trigger: 'change' },
          { type: 'number', min: 1, message: '限购数量必须大于等于1', trigger: 'change' }
        ],
        virtual_sales: [
          { required: false, message: '请输入虚拟销量', trigger: 'change' },
          { type: 'number', min: 0, message: '虚拟销量必须大于等于0', trigger: 'change' }
        ]
      },
      combinations: [
        {
          name: '',
          limit_num: 1,
          skus: []
        }
        // [{"name":"套餐搭配一","limit_num":2,"propertys":[{"id":0,"propertyid":24089}]}] //做到这里了*****************************************************
      ],
      dialogImageUrl: '',
      dialogVisible: false,
      shippingtemplists: [],
    }
  },
  methods: {
    /** 获取运费模板信息 **/
    getshippingtemplists() {
      var resource = this.$resource(this.GLOBAL.domain + "Shippingarea/index");
      resource.save({ act: 'getshippingtemplistsnew', token: this.$cookies.get('token'), temptypelists: 1, sort: 1, p: 1, rollpage: 10000000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.shippingtemplists = JSON.parse(Base64.decode(res.data.Data));
        }
      })
    },
    saveCombination() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.combinations.length < 1) {
            this.$message({
              type: 'error',
              message: '请添加组合搭配'
            })
            return false
          } else {
            this.submitCombination()
          }

        } else {
          return false
        }
      })
    },
    submitCombination() {
      this.loading = true

      const jsonData = this.combinations.map(combination => {
        return {
          name: combination.name,
          limit_num: combination.limit_num,
          propertys: combination.skus.map(sku => {
            return {
              id: sku.id,
              propertyid: sku.propertyid,
              activity_price: sku.activity_price
            }
          })
        }
      })

      this.$axios({
        url: this.GLOBAL.domain + 'Combination/index',
        method: 'POST',
        data: {
          act: this.form.id ? 'edit_combination' : 'add_combination',
          ...this.form,
          json_data: JSON.stringify(jsonData)
        }
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          // 重置表单
          this.resetForm()
        })
        .finally(() => {
          this.loading = false
        });
    },
    // 重置表单
    resetForm() {
      this.form = {
        image: null,
        name: '',
        price: 0,
        underline_price: 0,
        limit_num: false,
        limit_type: '',
        limit_num: 1,
        virtual_sales: 0,
        status: '1',
        shipping_tempidid: ''
      }
      this.combinations = [
        {
          name: '',
          limit_num: 1,
          skus: [],
          currentPage: 1,
          pageSize: 5
        }
      ]
      this.$refs.uploadRes.clearFiles()
      this.$refs.form.resetFields()
    },
    addSku(index) {
      this.currentIndex = index
      this.$refs.skuDialog.initDialog(this.combinations[index].skus)
    },
    handleChooseSku(datas) {
      this.combinations[this.currentIndex].skus = datas
      this.$nextTick(() => {
        this.currentIndex = null
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.form.image = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleUpdateSuccess(res) {
      var data = JSON.parse(Base64.decode(res.Data));
      if (data.Result == 0) {
        this.form.image = data.imgsrc
      }
    },
    beforeUpload(file) {
      const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPGorPNG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      if (isJPGorPNG && isLt2M) {
        this.form.image = file;
      }
      return isJPGorPNG && isLt2M;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('submit!', this.form);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addCombination() {
      this.combinations.push({
        name: '',
        limit_num: 1,
        skus: [],
        currentPage: 1,
        pageSize: 5
      });
    },
    removeCombination(index) {
      if (this.combinations.length <= 1) {
        this.$message.error('至少需要保留一个组合');
        return;
      }
      this.combinations.splice(index, 1);
    },
    editSku(combination, index) {
      console.log('编辑商品SKU', combination, index);
    },
    removeSku(combination, index) {
      combination.skus.splice(index, 1);
    },
    paginatedSkus(combination) {
      const start = (combination.currentPage - 1) * combination.pageSize;
      const end = start + combination.pageSize;
      return combination.skus.slice(start, end);
    },
    handleSizeChange(combination, val) {
      combination.pageSize = val;
      combination.currentPage = 1;
    },
    handleCurrentChange(combination, val) {
      combination.currentPage = val;
    },
    // 获取组合套餐详情
    getDetail() {
      this.$axios({
        url: this.GLOBAL.domain + 'Combination/index',
        method: 'POST',
        data: {
          act: 'get_combination_info',
          id: this.form.id
        }
      })
        .then(res => {
          console.log(res, '获取到的详情接口');
          this.form = {
            image: res.Data.image,
            name: res.Data.name,
            price: res.Data.price,
            underline_price: res.Data.underline_price,
            limit_num: res.Data.limit_num,
            limit_type: res.Data.limit_type,
            limit_num: res.Data.limit_num,
            virtual_sales: res.Data.virtual_sales,
            status: res.Data.status,
            shipping_tempidid: res.Data.shipping_tempidid,
            id: res.Data.id
            // ...res.Data
          }
          this.form.shipping_tempidid == '0' ? this.form.shipping_tempidid = '' : ''
          this.fileList = [{
            url: this.form.image
          }]
          this.combinations = res.Data.combination_items.map(item => {
            return {
              name: item.name,
              limit_num: item.limit_num,
              skus: item.combination_skus,
            }
          })
        })
    }
  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.combination-box {
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 10px;
  padding-top: 0;
  border-radius: 5px;
}

.combination-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: 0 10px;
  border-bottom: 1px solid #ccc;
}

.flex-box {
  display: flex;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.header-label {
  font-size: 14px;
  margin-right: 5px;
  color: #333333;
}

.block {
  text-align: right;
}

.goodsInfo {
  display: flex;
  align-items: center;
}

.goodsInfo .left {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  margin-right: 10px;
}

.goodsInfo .left img {
  width: 100%;
  height: 100%;
}

.goodsInfo .prop {
  color: #a1a1a1;
}
</style>


// WEBPACK FOOTER //
// src/components/mall/CombinationEdit.vue